export const Header = () => (
  <div className="ml-2 flex flex-shrink-0 items-center justify-between gap-2 overflow-hidden p-2 pt-4">
    <div className="flex">
      <a className="flex" href="/">
        <img alt="me" height="32" src="/anymind-logo.svg" width="122" />
        <img alt="me" className="p-1" height="15" src="/med-logo.svg" width="43" />
      </a>
    </div>
  </div>
);
